(function() {

  /* PROMOZIONE OGNI 3 SIDRI, BOLEE O PICHET IN OMAGGIO */
  const QUALIFYING_VARIANT_IDS = [50450913493335, 50451091489111, 51823777415511, 51823883911511, 50451043746135, 52789902082391]; // prodotti che contano per la promo
  const GIFT_VARIANT_IDS = [52078254358871, 52088248074583, 52088241914199]; // possibili regali
  const THRESHOLD = 3; // ogni 3 prodotti = 1 regalo
  
  let isGiftSyncing = false;

  // Controlla live se una variante regalo è disponibile (senza cache)
  async function isGiftVariantAvailable(variantId) {
    try {
      const res = await fetch(`/variants/${variantId}.js`, {
        headers: { 'Accept': 'application/json' }
      });
      if (!res.ok) {
        console.error('[promo-gift] Errore HTTP nel controllo disponibilità variante regalo', variantId, res.status);
        return false;
      }
      const variant = await res.json();
      // Disponibile solo se Shopify dice che è vendibile
      return !!(variant && variant.available);
    } catch (err) {
      console.error('[promo-gift] Errore nel controllo disponibilità variante regalo', variantId, err);
      return false;
    }
  }

  async function getAvailableGiftVariantIds() {
    const checks = GIFT_VARIANT_IDS.map(async (id) => {
      const available = await isGiftVariantAvailable(id);
      return available ? id : null;
    });

    const results = await Promise.all(checks);
    return results.filter(Boolean);
  }
  
  async function addGift(variantId, quantity = 1) {
    console.log('[promo-gift] Aggiungo regalo variant_id=', variantId, 'qty=', quantity);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
        properties: {
          Nota: "Regalo promozione Sidri"
        }
      })
    }).then(res => res.json());
  }
  
  async function changeLineItem(lineItemKey, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: lineItemKey,
        quantity: quantity
      })
    }).then(res => res.json());
  }
  
  async function internalSyncPromoGift(cartFromOutside) {
    if (isGiftSyncing) {
      return;
    }
    isGiftSyncing = true;
    
    try {
      const cart = cartFromOutside || await fetch('/cart.js').then(r => r.json());
      
      let qualifyingQty = 0;
      let currentGifts = [];
      
      cart.items.forEach(item => {
        const variantId = item.variant_id;
        
        // Prodotti che contano per la promo
        if (QUALIFYING_VARIANT_IDS.includes(variantId)) {
          qualifyingQty += item.quantity;
        }
        
        // Prodotti regalo
        if (GIFT_VARIANT_IDS.includes(variantId)) {
          currentGifts.push({
            key: item.key,
            quantity: item.quantity
          });
        }
      });
      
      const requiredGifts = Math.floor(qualifyingQty / THRESHOLD);
      const currentGiftsQty = currentGifts.reduce((sum, g) => sum + g.quantity, 0);
      
      
      // Nessun prodotto promo → togli tutti i regali
      if (qualifyingQty === 0 && currentGiftsQty > 0) {
        for (const gift of currentGifts) {
          await changeLineItem(gift.key, 0);
        }
        isGiftSyncing = false;
        return;
      }
      
      // Aggiungere regali mancanti (tenendo conto della disponibilità a magazzino)
      if (requiredGifts > currentGiftsQty) {
        let giftsToAdd = requiredGifts - currentGiftsQty;

        const availableGiftIds = await getAvailableGiftVariantIds();
        if (!availableGiftIds.length) {
        } else {
          while (giftsToAdd > 0) {
            const randomGiftId = availableGiftIds[Math.floor(Math.random() * availableGiftIds.length)];
            await addGift(randomGiftId, 1);
            giftsToAdd--;
          }
        }
      }
      
      // Rimuovere regali in eccesso
      if (requiredGifts < currentGiftsQty) {
        let giftsToRemove = currentGiftsQty - requiredGifts;
        
        for (const gift of currentGifts) {
          if (giftsToRemove <= 0) break;
          
          const newQty = Math.max(gift.quantity - giftsToRemove, 0);
          const removed = gift.quantity - newQty;
          
          await changeLineItem(gift.key, newQty);
          giftsToRemove -= removed;
        }
      }
      
    } catch (e) {
      console.error('[promo-gift] ERRORE:', e);
    }
    
    isGiftSyncing = false;
  }
  
  window.syncPromoGift = function(cart) {
    return internalSyncPromoGift(cart);
  };
  
})();
